<template>
    <div>
        <div class="suggestion-container" style="width: 100% !important; margin-bottom: 30px">
            <div class="d-flex">
                <v-icon class="mr-2" color="warning">info</v-icon>
                <div class="mt-auto mb-auto">
                    <b style="font-size: 18px;">Différence détectée</b>
                </div>
            </div>

            <div class="mt-3">
                Une nouvelle commune a été détectée sur Google : <b>{{ suggestedCommune.name }}</b>
            </div>

            <div class="d-flex justify-content-center flex-wrap mt-4 mb-2" v-if="!readOnly">
                <v-btn class="text-none mr-5"
                       color="warning"
                       large
                       style="border-radius: 25px; border-width: 2px; font-weight: bold"
                       outlined
                       @click="setCommune()">
                    Modifier cette commune
                </v-btn>

                <v-btn class="text-none ml-5"
                       text
                       color="#ffa533"
                       style="font-size: 16px"
                       @click="removeCommuneSuggestion()">
                    Ignorer
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"

export default {
    name: "CitySuggestion",
    computed: {
        ...mapState("web_form", [
            "provider",
            "suggestedCommune",
            "readOnly",
        ]),
    },
    methods: {
        ...mapMutations("web_form", ["setSuggestedCommune", "pushCommune", "setSearchCommunes"]),
        setCommune() {
            this.pushCommune(this.suggestedCommune)

            this.provider.localisation.commune = this.suggestedCommune

            this.setSearchCommunes(this.provider.localisation.commune.name)

            this.setSuggestedCommune(null)
        },
        removeCommuneSuggestion() {
            this.setSuggestedCommune(null)
        },
    },
}
</script>

